import PropTypes from 'prop-types';
import ClosedCaptionOutlined from '@mui/icons-material/ClosedCaptionOutlined';
import Switch from '@mui/material/Switch';

const LiveCaptionsToggle = ({
  checked,
  deviceFieldStyle = false,
  disabled = false,
  onChange,
  t,
}) => (
  <div
    className={`live-captions-toggle${
      deviceFieldStyle ? ' vonage-device-field' : ''
    }`}
  >
    <div
      className={
        deviceFieldStyle
          ? 'vonage-device-field__header'
          : 'live-captions-toggle__control'
      }
    >
      <span
        className={
          deviceFieldStyle
            ? 'vonage-device-field__label'
            : 'live-captions-toggle__label'
        }
      >
        {deviceFieldStyle && <ClosedCaptionOutlined />}
        {t('liveCaptions.label')}
      </span>
      <Switch
        checked={checked}
        disabled={disabled}
        onChange={(_, enabled) => onChange(enabled)}
        slotProps={{
          input: { 'aria-label': t('liveCaptions.toggleLabel') },
        }}
      />
    </div>
    <p
      className={
        deviceFieldStyle
          ? 'live-captions-toggle__description vonage-device-field__help'
          : 'live-captions-toggle__description'
      }
    >
      {t('liveCaptions.description')}
    </p>
  </div>
);

LiveCaptionsToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  deviceFieldStyle: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default LiveCaptionsToggle;
